import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import FormLogic from '../views/FormLogic.vue'
import Default from '../views/Default.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:level',
    name: 'Home',
    component: Home    
  },
  {
    path: '/formulario',
    name: 'Formulario',
    component: FormLogic
  },
  {
    path: '*',
    component: Default
  }
]

const router = new VueRouter({
  routes
})

export default router
